export const NEWS_INITIAL_FORM = {
  title: "",
  content: "",
  image_url: "",
  is_active: true,
};

export const NEWS_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Toutes",
    description: "Afficher toutes les actualités.",
  },
  {
    value: "active",
    label: "Publiées",
    description: "Visibles sur le site public.",
  },
  {
    value: "inactive",
    label: "Brouillons",
    description: "Masquées du site public.",
  },
];

export const NEWS_LIMIT_OPTIONS = [10, 20, 50, 100];

export const NEWS_FORM_HELPERS = [
  "Privilégiez un titre court, clair et compréhensible rapidement.",
  "Ajoutez une image lorsque l’information doit attirer l’attention.",
  "Structurez le texte avec du gras, des listes ou des couleurs avec modération.",
];

export const MEDIA_CATEGORY_DEFAULT = "news";